import cx from 'classnames';
import PropTypes from 'prop-types';

import LoadingSpinner from '@app/components/LoadingSpinner';

const propTypes = {
  children: PropTypes.node,
  overLayClassName: PropTypes.string,
  spinnerClassName: PropTypes.string,
};

const defaultProps = {
  children: null,
  overLayClassName: '',
  spinnerClassName: '',
};

/**
 * LocalLoadingSpinner은 로딩이 뜰 때, overLay가 로딩에 해당하는 컴포넌트 만을 덮는 것을 의미합니다.
 */
function LocalLoadingSpinner(props) {
  const { children, overLayClassName, spinnerClassName } = props;
  return (
    <div className="LoadingSpinner--wrapper">
      <div className={cx('Overlay', 'LoadingSpinner__absolute-overlay', overLayClassName)} />
      <div className={cx('LoadingSpinner__spinner', spinnerClassName)}>
        <LoadingSpinner color="white" />
      </div>
      {children}
    </div>
  );
}

LocalLoadingSpinner.propTypes = propTypes;
LocalLoadingSpinner.defaultProps = defaultProps;

export default LocalLoadingSpinner;
